import { whenAmazonTakt } from '@amzn/takt-utils';
import { ChromeComponent } from 'src/constants';

export const logWithTakt = (context: unknown, details: unknown): void => {
  if (window && (window as any).AmazonTakt) {
    (window as any).AmazonTakt.logCustom({
      context,
      details: JSON.stringify(details),
    });
  }
};

export const logMetadata = (metadata: unknown): void => {
  if (window && (window as any).AmazonTakt) {
    (window as any).AmazonTakt.addVisitMetadata(metadata);
  }
};

export const markComponentStart = (component: string): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.waitForComponentsReady('AACChrome', [component]);
    amazonTakt.markComponentReady(
      component,
      amazonTakt.ComponentReadyState.START,
    );
  });
};

export const markComponentReady = (component: string): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      component,
      amazonTakt.ComponentReadyState.READY,
    );
  });
};

export const initTakt = (): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      'AACChrome',
      amazonTakt.ComponentReadyState.START,
    );
  });
};

export const markAACChromeReady = (): void => {
  whenAmazonTakt((amazonTakt) => {
    amazonTakt.markComponentReady(
      'AACChrome',
      amazonTakt.ComponentReadyState.READY,
    );
  });
};

interface TaktAttributes {
  'data-takt-id': string;
  'data-takt-value'?: string;
}

export const getTaktAttributes = (
  id: string,
  component?: ChromeComponent,
  value?: Record<string, string>,
  allToolsEnabled?: boolean,
): TaktAttributes | undefined => {
  if (!id) {
    return undefined;
  }

  const componentPrefixes: Record<string, string> = {
    nav: allToolsEnabled ? 'nav_global_tools_' : 'nav_global_',
    allToolsNav: 'nav_tools_panel_',
    pivotNav: 'nav_pivot_',
    footer: 'footer_',
    header: 'header_',
  };

  const prefix = componentPrefixes[component ?? ''] || 'chrome_';
  const taktId =
    component === 'nav' && id.startsWith('aac-menu-item-')
      ? id.replace('aac-menu-item-', prefix)
      : prefix + id;

  return {
    'data-takt-id': taktId,
    ...(value && { 'data-takt-value': JSON.stringify(value) }),
  };
};
